export default __webpack_public_path__ + "static/media/preview.bea41c21.webp";